let redirecting = false;

/** Build the BFF login URL, preserving where the user was. */
export const buildBffLoginUrl = (returnUrl?: string): string => {
  const target = returnUrl ?? window.location.pathname + window.location.search;
  return `/bff/login?returnUrl=${encodeURIComponent(target)}`;
};

/**
 * Navigate to the BFF login endpoint (which kicks off the Keycloak OIDC flow;
 * silent if the SSO session is still valid, otherwise prompts login).
 *
 * Guarded so a burst of parallel 401s (a page firing several requests when the
 * session expires) triggers exactly one navigation, and so the route guard and
 * a 401 can't double-navigate.
 */
export const redirectToBffLogin = (returnUrl?: string): void => {
  if (redirecting) return;
  redirecting = true;
  window.location.href = buildBffLoginUrl(returnUrl);
};
